(() => {
  const currentPage = window.location.pathname;
  if (currentPage !== '/cart') {
    const initProductDrawer = (element) => {
      let container = document.currentScript ? document.currentScript.parentElement : element;

      if (container && container.classList.contains("popular-products-section")) {
        const drawerButton = container.querySelector(".product-drawer__button");
        const closeButton = container.querySelector(".product-drawer__close"); 
        const overlay = container.querySelector(".product-drawer__overlay");

        if (closeButton) {
          closeButton.addEventListener("click", () => {
            closeButton.closest(".product-drawer__inner").classList.remove("active");
            document.body.classList.remove("overflow-hidden-products");
            document.body.classList.remove("overflow-visible");
          });
        }

        if (overlay) {
          overlay.addEventListener("click", () => {
            overlay.closest(".product-drawer__inner").classList.remove("active");
            document.body.classList.remove("overflow-hidden-products");
            document.body.classList.remove("overflow-visible");
          });
        }

        const resizeObserver = new ResizeObserver((entries) => {
          if (document.body.clientWidth < 576) {
            const drawerInner = container.querySelector(".product-drawer__inner");
            if (drawerInner && drawerInner.classList.contains("active")) {
              document.body.classList.add("overflow-hidden-products");
            }

            if (drawerButton) {
              drawerButton.onclick = () => {
                drawerButton.closest(".product-drawer__inner").classList.toggle("active");
                document.body.classList.toggle("overflow-hidden-products");
                document.body.classList.add("overflow-visible");
              };
            }

          } else {
            document.body.classList.remove("overflow-hidden-products");
            const drawer = container.querySelector(".product-drawer__inner");
            const drawerHeight = drawer ? drawer.clientHeight : 0;
            const buttonHeight = drawerButton ? drawerButton.clientHeight + 25 : 0;
            const products = container.querySelector(".product-drawer__products");
            if (products) {
              products.style.setProperty("--max-height", (drawerHeight - buttonHeight) + "px");
            }
            if (drawerButton) {
              drawerButton.onclick = () => {
                drawerButton.closest(".product-drawer__inner").classList.toggle("active");
              };
            }
          }
        });

        resizeObserver.observe(container);

        const videoElement = container.querySelector(".product-drawer__video_static");
        if (videoElement) {
          const videoObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.play();
              } else {
                entry.target.pause();
              }
            });
          });

          videoObserver.observe(videoElement.querySelector("video"));
        }
      }
    };

    initProductDrawer();

    document.addEventListener("shopify:section:load", function(event) {
      initProductDrawer(event.target);
    });
  }
})();
